/**
 * The frame every dialog form sits in: a scrolling body and a fixed footer.
 *
 * Its own module because both forms.jsx and PasswordForms.jsx need it, and
 * PasswordForms exists precisely to stay out of forms.jsx — importing it back
 * for the shell would defeat the point.
 */
import { ErrorNote } from './ui.jsx';
import { Icon } from '../lib/icons.jsx';

/** Wraps the shared submit/cancel footer so every dialog behaves the same way. */
export function FormShell({ id, onSubmit, busy, error, children, submitLabel = 'Save', close, onDelete, deleteLabel, extraActions, disabled = false }) {
  return (
    <>
      <form id={id} onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>{children}</form>
      <ErrorNote error={error} />
      <div className="modal-f" style={{ margin: '18px -22px -20px' }}>
        {onDelete && (
          <button type="button" className="btn btn-danger" onClick={onDelete}>
            <Icon name="trash" />{deleteLabel ?? 'Deactivate'}
          </button>
        )}
        {extraActions}
        <span className="ml-auto" />
        <button type="button" className="btn" onClick={close}>Cancel</button>
        <button type="submit" form={id} className="btn btn-primary" disabled={busy || disabled}>
          <Icon name="save" />{busy ? 'Saving…' : submitLabel}
        </button>
      </div>
    </>
  );
}
